export const getFilterJurisdictions = (state) => state.jurisdictions;
export const getFilterListOfAgencies = (state) => state.agencies;
// Currently-applied filters (the `filter` and `oldFilter` slices mirror each other).
export const getGeneralFilters = (state) => state.oldFilter.generalFilters;
